import { mctRequest } from '@/api/axios'
import { utcToZonedTime, format } from 'date-fns-tz'

export const globalSearchCountApi = <T = any>(
  searchVal: string,
  searchLevel: string
): Promise<T> => {
  const config = {
    url: `/search/globalSearchCount?keyword=${encodeURI(
      searchVal
    )}&searchType=${searchLevel}`
  }
  return mctRequest.request<T>(config)
}

export const globalSearchApi = <T = any>(
  searchVal: string,
  searchLevel: string,
  pageNum: number
): Promise<T> => {
  const config = {
    url: `/search/globalSearch?keyword=${encodeURI(
      searchVal
    )}&searchType=${searchLevel}&pageNum=${pageNum}&pageSize=50`
  }
  return mctRequest.request<T>(config)
}

export const lastHourStatusApi = <T = any>(
  serverIdList: number[]
): Promise<T> => {
  const currUtcTimeStr = format(
    utcToZonedTime(new Date(), 'UTC'),
    'yyyy-MM-dd HH:00:00'
  )
  const serverIds = serverIdList.join(',')
  const config = {
    url: `/clusterlist/queryZoneServerDetail?serverIds=${serverIds}&startTime=${currUtcTimeStr}&timeDuration=1&timeZone=0`
  }
  return mctRequest.request<T>(config)
}

export const serverTypeListApi = <T = any>(): Promise<T> => {
  const config = {
    url: '/svrTypeMapping/queryServerType'
  }
  return mctRequest.request<T>(config)
}
